export const ACCEPTED_IMAGE_FILE_LIST = [
  '.jpg',
  '.JPG',
  '.jpeg',
  '.JPEG',
  '.png',
  '.PNG',
  '.gif',
  '.GIF',
  '.svg',
  '.SVG',
  '.svgz',
  '.SVGZ',
  '.webp',
  '.WEBP',
];
export const ACCEPTED_FAVICON_FILE_LIST = ['.ico', '.ICO', '.png', '.PNG', '.jpg', '.JPG', '.jpeg', '.JPEG'];
export const ACCEPTED_OPEN_GRAPH_FILE_LIST = ['.jpg', '.JPG', '.jpeg', '.JPEG', '.png', '.PNG'];

export const ACCEPTED_VIDEO_FILE_LIST = ['.mp4', '.MP4', '.mov', '.MOV'];
